import PropTypes from 'prop-types'
import React from 'react'

export default (toggleProps) => (Target) => {
  class WithToggleProps extends React.Component {
    constructor () {
      super()

      this.state = { toggled: false }
    }

    render () {
      const { onToggle, ...props } = this.props
      const { toggled } = this.state

      return (
        <Target
          onToggle={(...args) => {
            this.setState({ toggled: !toggled })
            onToggle && onToggle(...args)
          }}
          {...props}
          {...(toggled ? toggleProps : {})}
        />
      )
    }
  }

  const displayName = Target.displayName || Target.name || 'Component'

  WithToggleProps.propTypes = {
    onToggle: PropTypes.func
  }

  WithToggleProps.displayName = `WithToggleProps(${displayName})`

  return WithToggleProps
}
